<template src="./produto-nao-encontrado.html"></template>
<style lang="less" scoped src="./produto-nao-encontrado.less"></style>

<script>

    export default {
        props:{
            campoDeBusca: String
        }
    }
</script>